import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import SearchBar from '../components/SearchBar';

export default function Home() {
  return (
    <div className="page">
      <Navbar />

      {/* Hero */}
      <section className="hero">
        <div className="container hero-inner">
          <h1>Timeshare Stays at a Fraction of the Cost</h1>
          <p>
            Owners list their unused weeks. Prices drop automatically as check-in approaches — the later you book, the better the deal.
            No cleaning fees, no service surcharges.
          </p>
          <div style={{ marginBottom: '2rem' }}>
            <SearchBar />
          </div>
          <div className="hero-cta">
            <Link to="/search" className="btn btn-primary">Find a Stay</Link>
            <Link to="/register?role=owner" className="btn btn-outline">List Your Property</Link>
          </div>
        </div>
      </section>

      {/* ── Three-way CTA ───────────────────────────────────────────────────── */}
      <section style={{ background: 'var(--surface-alt)', padding: '3.5rem 0' }}>
        <div className="container">
          <h2 style={{ textAlign: 'center', fontSize: 'var(--text-xl)', fontWeight: 700, marginBottom: '0.5rem', color: 'var(--brand-dark)' }}>
            How can we help you?
          </h2>
          <p style={{ textAlign: 'center', color: 'var(--ink-muted)', marginBottom: '2.25rem', fontSize: 'var(--text-base)' }}>
            ShareTime serves owners, renters, and buyers — all in one place.
          </p>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(270px, 1fr))', gap: '1.5rem' }}>

            {/* Rent */}
            <div style={{ background: 'var(--surface)', borderRadius: 'var(--radius-md)', padding: 'clamp(1.5rem, 5vw, 2.25rem) clamp(1.25rem, 4vw, 2rem)', boxShadow: '0 2px 16px rgba(30,58,95,0.08)', borderTop: '4px solid var(--brand-dark)', textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <div style={{ width: 52, height: 52, borderRadius: '50%', background: 'var(--brand-light)', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '1rem' }}>
                <svg width="26" height="26" fill="none" viewBox="0 0 24 24" stroke="var(--brand-dark)" strokeWidth="2">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M3 10l9-7 9 7v11a1 1 0 01-1 1H4a1 1 0 01-1-1V10z"/>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M9 21V12h6v9"/>
                </svg>
              </div>
              <h3 style={{ fontSize: 'var(--text-lg)', fontWeight: 700, color: 'var(--brand-dark)', margin: '0 0 0.75rem' }}>Looking to rent a timeshare?</h3>
              <p style={{ color: 'var(--ink-muted)', fontSize: 'var(--text-base)', lineHeight: 1.65, margin: '0 0 1.75rem', flex: 1 }}>
                Browse deeply discounted stays from real owners. Prices drop automatically every day — the longer you wait, the bigger the deal.
              </p>
              <Link to="/search" className="btn btn-primary" style={{ width: '100%', textAlign: 'center' }}>Browse Listings</Link>
            </div>

            {/* Own */}
            <div style={{ background: 'var(--surface)', borderRadius: 'var(--radius-md)', padding: 'clamp(1.5rem, 5vw, 2.25rem) clamp(1.25rem, 4vw, 2rem)', boxShadow: '0 2px 16px rgba(30,58,95,0.08)', borderTop: '4px solid var(--success)', textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <div style={{ width: 52, height: 52, borderRadius: '50%', background: 'var(--success-bg)', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '1rem' }}>
                <svg width="26" height="26" fill="none" viewBox="0 0 24 24" stroke="var(--success)" strokeWidth="2">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8v1m0 8v1m0-10V4m0 18v-1"/>
                  <circle cx="12" cy="12" r="9" strokeLinecap="round"/>
                </svg>
              </div>
              <h3 style={{ fontSize: 'var(--text-lg)', fontWeight: 700, color: 'var(--success)', margin: '0 0 0.75rem' }}>Own a timeshare you're not using?</h3>
              <p style={{ color: 'var(--ink-muted)', fontSize: 'var(--text-base)', lineHeight: 1.65, margin: '0 0 1.75rem', flex: 1 }}>
                Stop leaving money on the table. List your week in minutes and let ShareTime's price engine find you a buyer — automatically.
              </p>
              <Link to="/register?role=owner" className="btn" style={{ width: '100%', textAlign: 'center', background: 'var(--success)', color: 'var(--surface)', border: 'none' }}>List Your Stay</Link>
            </div>

            {/* Buy */}
            <div style={{ background: 'var(--surface)', borderRadius: 'var(--radius-md)', padding: 'clamp(1.5rem, 5vw, 2.25rem) clamp(1.25rem, 4vw, 2rem)', boxShadow: '0 2px 16px rgba(30,58,95,0.08)', borderTop: '4px solid var(--warning)', textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <div style={{ width: 52, height: 52, borderRadius: '50%', background: 'var(--warning-bg)', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '1rem' }}>
                <svg width="26" height="26" fill="none" viewBox="0 0 24 24" stroke="var(--warning)" strokeWidth="2">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z"/>
                </svg>
              </div>
              <h3 style={{ fontSize: 'var(--text-lg)', fontWeight: 700, color: 'var(--warning)', margin: '0 0 0.75rem' }}>Looking to buy a timeshare?</h3>
              <p style={{ color: 'var(--ink-muted)', fontSize: 'var(--text-base)', lineHeight: 1.65, margin: '0 0 1.75rem', flex: 1 }}>
                Browse timeshare units listed for sale directly by owners at our featured resorts. No agent fees, no middleman — just real deals.
              </p>
              <Link to="/search" className="btn" style={{ width: '100%', textAlign: 'center', background: 'var(--warning)', color: 'var(--surface)', border: 'none' }}>Browse For Sale</Link>
            </div>

          </div>
        </div>
      </section>

      {/* Social proof */}
      <section className="section" style={{ background: 'var(--surface-alt)' }}>
        <div className="container">
          <div className="stat-cards-row">
            <div className="stat-proof-card">
              <div className="stat-proof-icon">
                <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="var(--brand-dark)" strokeWidth="2">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M3 21h18M5 21V8l7-4 7 4v13M9 21v-6h6v6" />
                </svg>
              </div>
              <div className="stat-proof-number">660+</div>
              <div className="stat-proof-label">Florida Resorts</div>
            </div>
            <div className="stat-proof-card">
              <div className="stat-proof-icon">
                <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="var(--brand-dark)" strokeWidth="2">
                  <circle cx="12" cy="12" r="9" strokeLinecap="round" />
                  <path strokeLinecap="round" strokeLinejoin="round" d="M9.5 9.5a2.5 2.5 0 015 0c0 1.5-2.5 2-2.5 3.5M12 16.5h.01" />
                </svg>
              </div>
              <div className="stat-proof-number">$0</div>
              <div className="stat-proof-label">No Hidden Fees</div>
            </div>
            <div className="stat-proof-card">
              <div className="stat-proof-icon">
                <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="var(--brand-dark)" strokeWidth="2">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M17 6l-6.5 6.5L7 9l-4 4M17 6h-4M17 6v4" />
                </svg>
              </div>
              <div className="stat-proof-number">Daily</div>
              <div className="stat-proof-label">Prices Drop Automatically</div>
            </div>
          </div>
        </div>
      </section>

      {/* How it works — owners vs buyers */}
      <section className="section">
        <div className="container">
          <h2 style={{ textAlign: 'center', marginBottom: '2.5rem', fontSize: 'var(--text-xl)', fontWeight: 700 }}>
            How ShareTime Works
          </h2>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '2rem' }}>
            <div className="hiw-card">
              <h3 style={{ fontSize: 'var(--text-md)', fontWeight: 700, marginBottom: '1.5rem', color: 'var(--brand-dark)' }}>For Owners</h3>
              <div className="hiw-step">
                <div className="hiw-step-num" style={{ background: 'var(--brand-dark)' }}>1</div>
                <div>
                  <div className="hiw-step-title">Set a price range</div>
                  <div className="hiw-step-text">Choose a starting price and the lowest price you'll accept.</div>
                </div>
              </div>
              <div className="hiw-step">
                <div className="hiw-step-num" style={{ background: 'var(--brand-dark)' }}>2</div>
                <div>
                  <div className="hiw-step-title">Price drops automatically</div>
                  <div className="hiw-step-text">As check-in gets closer, the price steps down each day until it sells.</div>
                </div>
              </div>
              <div className="hiw-step">
                <div className="hiw-step-num" style={{ background: 'var(--brand-dark)' }}>3</div>
                <div>
                  <div className="hiw-step-title">Get paid</div>
                  <div className="hiw-step-text">Once a buyer books, funds are held securely and released to you after the stay.</div>
                </div>
              </div>
            </div>
            <div className="hiw-card">
              <h3 style={{ fontSize: 'var(--text-md)', fontWeight: 700, marginBottom: '1.5rem', color: 'var(--success)' }}>For Buyers</h3>
              <div className="hiw-step">
                <div className="hiw-step-num" style={{ background: 'var(--success)' }}>1</div>
                <div>
                  <div className="hiw-step-title">Browse real weeks</div>
                  <div className="hiw-step-text">See resorts, dates, and today's price up front.</div>
                </div>
              </div>
              <div className="hiw-step">
                <div className="hiw-step-num" style={{ background: 'var(--success)' }}>2</div>
                <div>
                  <div className="hiw-step-title">Watch the price fall</div>
                  <div className="hiw-step-text">The longer you wait, the better the deal — with no bidding required.</div>
                </div>
              </div>
              <div className="hiw-step">
                <div className="hiw-step-num" style={{ background: 'var(--success)' }}>3</div>
                <div>
                  <div className="hiw-step-title">Book instantly</div>
                  <div className="hiw-step-text">Pay today's price and you're confirmed — no cleaning fees, no service surcharges.</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Value props */}
      <section className="value-prop">
        <div className="container">
          <h2 style={{ fontWeight: 700, fontSize: 'var(--text-xl)', marginBottom: '0.5rem' }}>
            Why ShareTime?
          </h2>
          <div className="props">
            <div className="prop">
              <h3>No Hidden Fees</h3>
              <p>No cleaning fees, no service surcharges. The price you see is what you pay.</p>
            </div>
            <div className="prop">
              <h3>Price Transparency</h3>
              <p>Watch the price decay in real time. Know exactly when the deal hits your sweet spot.</p>
            </div>
            <div className="prop">
              <h3>Protected Payments</h3>
              <p>Stripe holds funds until your stay completes. Owners only get paid after you've checked in and out.</p>
            </div>
            <div className="prop">
              <h3>Auto Re-list on Cancel</h3>
              <p>If a buyer cancels, your listing automatically goes back on the market — no manual steps needed.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Owner CTA */}
      <section className="section" style={{ textAlign: 'center' }}>
        <div className="container">
          <h2 style={{ marginBottom: '0.75rem' }}>Own a timeshare?</h2>
          <p style={{ color: 'var(--ink-muted)', marginBottom: '1.5rem' }}>
            Stop letting your timeshare go unused. List it in under 5 minutes.
          </p>
          <Link to="/register?role=owner" className="btn btn-primary">Get Started as an Owner</Link>
        </div>
      </section>

      <Footer />
    </div>
  );
}
